export const CREATOR_REMINDERS_TYPE_RECONNECT_NETWORK = 'reconnect_network';
export const CREATOR_NOTIFICATIONS_TYPE_CONTENT_METRICS = 'content_metrics';
